import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { useForm } from 'react-hook-form'

const UpdateFeedbackSettings = ({ show, handleClose, onSubmit, data }) => {
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();

    useEffect(() => {
        if (data) {
            setValue("name", data?.name);
            setValue("value", Array.isArray(data.value) ? data.value.join(", ") : data.value);
        }
    }, [data, setValue]);

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Update Feedback Settings</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row g-3">
                        <div className="col-12">
                            <label className="form-label">Name</label>
                            <input type="text"
                                {...register("name", { required: "Name is required" })}
                                name="name"
                                className="form-control"
                                placeholder='Enter name' />
                            {errors?.name &&
                                <p className="text-danger">{errors?.name?.message}</p>
                            }
                        </div>

                        <div className="col-12">
                            <label className="form-label">Value</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter value"
                                {...register("value", { required: "Value is required" })}
                            />
                            {errors?.value &&
                                <p className="text-danger">{errors?.value?.message}</p>
                            }
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            <button type="submit" className="btn btn-primary">
                                Save
                            </button>
                        </div>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default UpdateFeedbackSettings